// extracted by mini-css-extract-plugin
export default {"logo_box":"index_logo_box_-FRl8","logoBox2":"index_logoBox2_Dt3YG","logo_title":"index_logo_title_kPCqB","logo_finace":"index_logo_finace_GP9pK"};